import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

export type SignInArrowIconProps = {
    className?: ClassName
    style?: React.CSSProperties
    width?: number
    height?: number
    color?: string
}

export function SignInArrowIcon({
    className,
    style,
    width = 23,
    height = 20,
    color = '#81E18B',
}: SignInArrowIconProps): React.ReactElement {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 23 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            style={{ color, ...style }}
        >
            <path
                d="M22.5 10C22.5 11.07 22.08 12.07 21.33 12.83L14.5 19.66V16.82L19.91 11.41C20.29 11.04 20.5 10.53 20.5 10C20.5 9.47 20.29 8.96 19.91 8.59L14.5 3.18V0.339996L21.33 7.17C22.08 7.93 22.5 8.93 22.5 10Z"
                fill="currentColor"
            />
            <path d="M16.5 9H0.5V11H16.5V9Z" fill="currentColor" />
        </svg>
    )
}
